export const timeFormated = (value: string | number): string =>
  value + ' minutes'

export const fileSizeFormatted = (size: string | number): string => {
  const sizeAsNumber = Number(size)
  if (sizeAsNumber > 1000000) {
    return (sizeAsNumber / 1000000).toFixed(1) + 'MB'
  } else {
    return Math.round(sizeAsNumber / 1000) + 'KB'
  }
}

export const anchorFormatted = (text: string): string => {
  let result = text
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')

  // CSS IDs cannot start with a number, add 'section-' prefix if it does
  if (/^\d/.test(result)) {
    result = 'section-' + result
  }

  // Ensure we have a valid result
  if (result === '' || result === 'section-') {
    result = 'section-default'
  }

  return result
}

export const slugToCamelCaseIdentifier = (str = ''): string => {
  let result = str
    .replace(/[^a-zA-Z0-9_]/g, '') // Removes non-alphanumeric characters and underscores
    .toLowerCase()
    .replace(/-(.)/g, (match, group1) => (group1 as string).toUpperCase())

  // If the string starts with a number, add an underscore at the beginning
  if (/^\d/.test(result)) {
    result = '_' + result
  }

  if (result === '') {
    console.warn('The string cannot be converted to a valid identifier')
    return ''
  }

  return result
}
